
// import React, { useEffect, useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
// import { Link } from "react-router-dom";

// import "swiper/css";
// import "swiper/css/navigation";

// import { AuthAPI } from "../api/AuthAPI";

// export default function HomeProducts() {
//   const [categories, setCategories] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [expandedId, setExpandedId] = useState(null);
//   const [loading, setLoading] = useState(false);

//   /* ================= LOAD CATEGORIES ================= */
//   useEffect(() => {
//     async function loadCategories() {
//       try {
//         const res = await AuthAPI.getcategories({ limit: 6 });

//         const data = res?.data?.data || [];

//         setCategories(
//           data.map((c) => ({
//             id: c.id,
//             title: c.name,
//             image: c.image,
//           })),
//         );
//       } catch (err) {
//         console.error("Failed to load categories", err);
//       }
//     }

//     loadCategories();
//   }, []);

//   /* ================= LOAD PRODUCTS ================= */
//   useEffect(() => {
//     async function loadProducts() {
//       try {
//         setLoading(true);

//         const res = await AuthAPI.getproducts({
//           page: 1,
//           limit: 4,
//         });

//         const data = res?.data?.data || [];

//         setProducts(
//           data.slice(0, 4).map((p) => ({
//             id: p.id,
//             name: p.name,
//             image: p.image || "/placeholder.png",
//             description: p.description || "",
//             price: p.price,
//             normal_price: p.normal_price,
//           })),
//         );
//       } catch (err) {
//         console.error("Failed to load products", err);
//       } finally {
//         setLoading(false);
//       }
//     }

//     loadProducts();
//   }, []);

//   return (
//     <section
//       className="
//         relative
//         overflow-hidden
//         py-20
//         bg-gradient-to-b
//         from-[#fff7fb]
//         via-[#fff]
//         to-[#f7f8ff]
//       "
//     >
//       {/* BACKGROUND BLURS */}
//       <div className="absolute top-0 left-0 w-72 h-72 bg-pink-200/30 blur-3xl rounded-full"></div>

//       <div className="absolute bottom-0 right-0 w-80 h-80 bg-blue-200/30 blur-3xl rounded-full"></div>

//       <div className="max-w-7xl mx-auto px-4 relative z-10">
//         {/* HEADING */}
//         <div className="text-center mb-14">
//           <span
//             className="
//               inline-block
//               px-5
//               py-2
//               rounded-full
//               bg-pink-100
//               text-pink-600
//               text-sm
//               font-medium
//               tracking-wide
//               uppercase
//               mb-5
//             "
//           >
//             Our Collection
//           </span>

//           <h2
//             className="
//               font-playfair
//               text-[40px]
//               md:text-[64px]
//               leading-[1]
//               font-bold
//               text-[#1A237E]
//             "
//           >
//             Premium Care
//             <span className="text-pink-500"> Products</span>
//           </h2>

//           <p
//             className="
//               mt-6
//               max-w-2xl
//               mx-auto
//               text-gray-600
//               text-[17px]
//               md:text-[19px]
//               leading-relaxed
//               font-poppins
//             "
//           >
//             Designed with comfort, confidence and care in mind — discover
//             premium sanitary and wellness essentials crafted for everyday
//             protection.
//           </p>
//         </div>

//         {/* NAVIGATION */}
//         <div
//           className="
//             swiper-button-prev
//             !w-6
//             !h-6
//             !bg-white/90
//             backdrop-blur-md
//             !rounded-full
//             !shadow-xl
//             border
//             border-pink-100
//             after:!text-[18px]
//             after:!text-[#1A237E]
//           "
//         ></div>

//         <div
//           className="
//             swiper-button-next
//             !w-6
//             !h-6
//             !bg-white/90
//             backdrop-blur-md
//             !rounded-full
//             !shadow-xl
//             border
//             border-pink-100
//             after:!text-[12px]
//             after:!text-[#1A237E]
//           "
//         ></div>

//         {/* PRODUCTS */}
//         <Swiper
//           modules={[Navigation]}
//           navigation={{
//             nextEl: ".swiper-button-next",
//             prevEl: ".swiper-button-prev",
//           }}
//           loop
//           spaceBetween={28}
//           breakpoints={{
//             0: {
//               slidesPerView: 1.15,
//             },

//             640: {
//               slidesPerView: 2,
//             },

//             1024: {
//               slidesPerView: 4,
//             },
//           }}
//           className="pb-14"
//         >
//           {products.map((product) => {
//             const expanded = expandedId === product.id;

//             const isLong = product.description.length > 80;

//             return (
//               <SwiperSlide key={product.id}>
//                 <div className="group h-full">
//                   <div
//                     className="
//                       relative
//                       h-full
//                       rounded-[32px]
//                       bg-white/80
//                       backdrop-blur-xl
//                       border
//                       border-pink-100
//                       shadow-[0_10px_40px_rgba(255,192,203,0.15)]
//                       overflow-hidden
//                       transition-all
//                       duration-500
//                       hover:-translate-y-2
//                       hover:shadow-[0_20px_60px_rgba(255,105,180,0.18)]

//                       flex
//                       flex-col
//                     "
//                   >
//                     {/* TOP GRADIENT */}
//                     <div
//                       className="
//                         absolute
//                         inset-x-0
//                         top-0
//                         h-32
//                         bg-gradient-to-b
//                         from-pink-50
//                         to-transparent
//                       "
//                     />

//                     {/* IMAGE */}
//                     <Link
//                       to={`/products/${product.id}`}
//                       className="
//                         relative
//                         flex
//                         justify-center
//                         items-center
//                         pt-10
//                         px-5
//                       "
//                     >
//                       <img
//                         src={product.image}
//                         alt={product.name}
//                         className="
//                           h-64
//                           object-contain
//                           transition-transform
//                           duration-500
//                           group-hover:scale-105
//                         "
//                       />
//                     </Link>

//                     {/* CONTENT */}
//                     <div
//                       className="
//                         px-6
//                         pb-7
//                         pt-2

//                         flex
//                         flex-col
//                         flex-1
//                       "
//                     >
//                       {/* TITLE */}
//                       <Link to={`/products/${product.id}`}>
//                         <h3
//                           className="
//                             font-poppins
//                             text-[18px]
//                             font-semibold
//                             text-[#1A237E]
//                             leading-snug
//                             min-h-[72px]
//                           "
//                         >
//                           {product.name}
//                         </h3>
//                       </Link>

//                       {/* DESCRIPTION */}
//                       <p
//                         className={`
//                           mt-3
//                           text-[14px]
//                           leading-relaxed
//                           text-gray-600
//                           font-poppins
//                           min-h-[72px]
//                           ${expanded ? "" : "line-clamp-3"}
//                         `}
//                       >
//                         {product.description}
//                       </p>

//                       {/* READ MORE */}
//                       {isLong && (
//                         <button
//                           type="button"
//                           onClick={(e) => {
//                             e.preventDefault();

//                             setExpandedId(expanded ? null : product.id);
//                           }}
//                           className="
//                             mt-2
//                             text-pink-500
//                             text-sm
//                             font-medium
//                             hover:text-pink-600
//                             text-left
//                           "
//                         >
//                           {expanded ? "Read less" : "Read more"}
//                         </button>
//                       )}

//                       {/* PUSH CONTENT DOWN */}
//                       <div className="mt-auto">
//                         {/* PRICE */}
//                         <div
//                           className="
//                             mt-6
//                             flex
//                             items-center
//                             gap-3
//                           "
//                         >
//                           {product.price && (
//                             <span
//                               className="
//                                 text-2xl
//                                 font-bold
//                                 text-[#1A237E]
//                               "
//                             >
//                               ₹{product.price}
//                             </span>
//                           )}

//                           {product.normal_price && (
//                             <span
//                               className="
//                                 text-sm
//                                 text-gray-400
//                                 line-through
//                               "
//                             >
//                               ₹{product.normal_price}
//                             </span>
//                           )}
//                         </div>

//                         {/* BUTTONS */}
//                         <div className="mt-6 flex gap-3">
//                           {/* VIEW PRODUCT */}
//                           <Link
//                             to={`/products/${product.id}`}
//                             className="
//                               flex-1
//                               py-3.5
//                               px-2
//                               rounded-full
//                               bg-gradient-to-r
//                               from-pink-500
//                               to-pink-400
//                               text-white
//                               font-medium
//                               text-sm
//                               tracking-wide
//                               transition-all
//                               duration-300
//                               hover:shadow-lg
//                               hover:scale-[1.02]

//                               flex
//                               items-center
//                               justify-center
//                             "
//                           >
//                             View Product
//                           </Link>

//                           {/* CART BUTTON */}
//                           <button
//                             className="
//                               w-14
//                               rounded-full
//                               border
//                               border-pink-200
//                               bg-white
//                               text-[#1A237E]

//                               flex
//                               items-center
//                               justify-center

//                               hover:bg-pink-50
//                               hover:shadow-md

//                               transition-all
//                               duration-300
//                             "
//                           >
//                             🛒
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </SwiperSlide>
//             );
//           })}
//         </Swiper>

//         {/* VIEW ALL */}
//         <div className="text-center mt-4">
//           <Link
//             to="/products"
//             className="
//               inline-flex
//               items-center
//               gap-3
//               px-10
//               py-4
//               rounded-full
//               bg-[#1A237E]
//               text-white
//               font-medium
//               tracking-wide
//               transition-all
//               duration-300
//               hover:scale-105
//               hover:shadow-2xl
//             "
//           >
//             Explore All Products
//           </Link>
//         </div>
//       </div>
//     </section>
//   );
// }














import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import { AuthAPI } from "../api/AuthAPI";
import { useCart } from "../context/CartContext";
import toast from "react-hot-toast";
          import RichText from "./RichText";
export default function HomeProducts() {
  const { addToCart } = useCart();

  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const [loading, setLoading] = useState(false);

  /* ================= LOAD CATEGORIES ================= */
  useEffect(() => {
    async function loadCategories() {
      try {
        const res = await AuthAPI.getcategories({ limit: 6 });

        const data = res?.data?.data || [];

        setCategories(
          data.map((c) => ({
            id: c.id,
            title: c.name,
            image: c.image,
          })),
        );
      } catch (err) {
        console.error("Failed to load categories", err);
      }
    }

    loadCategories();
  }, []);

  /* ================= LOAD PRODUCTS ================= */
  useEffect(() => {
    async function loadProducts() {
      try {
        setLoading(true);

        const res = await AuthAPI.getproducts({
          page: 1,
          limit: 4,
          sort:"old"
        });

        const data = res?.data?.data || [];

        setProducts(
          data.slice(0, 4).map((p) => ({
            id: p.id,
            name: p.name,
            image: p.image || "/placeholder.png",
            description: p.description || "",
            price: p.price,
            normal_price: p.normal_price,
            is_out_of_stock: p.is_out_of_stock, // ✅
          })),
        );
      } catch (err) {
        console.error("Failed to load products", err);
      } finally {
        setLoading(false);
      }
    }

    loadProducts();
  }, []);

  return (
    <section
      className="
        relative
        overflow-hidden
        py-20
        bg-gradient-to-b
        from-[#fff7fb]
        via-[#fff]
        to-[#f7f8ff]
      "
    >
      {/* BACKGROUND BLURS */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-pink-200/30 blur-3xl rounded-full"></div>

      <div className="absolute bottom-0 right-0 w-80 h-80 bg-blue-200/30 blur-3xl rounded-full"></div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">

        {/* HEADING */}
        <div className="text-center mb-14">
          <span
            className="
              inline-block
              px-5
              py-2
              rounded-full
              bg-pink-100
              text-pink-600
              text-sm
              font-medium
              tracking-wide
              uppercase
              mb-5
            "
          >
            Our Collection
          </span>

          <h2
            className="
              font-playfair
              text-[40px]
              md:text-[64px]
              leading-[1]
              font-bold
              text-[#1A237E]
            "
          >
            Premium Care
            <span className="text-pink-500"> Products</span>
          </h2>

          <p
            className="
              mt-6
              max-w-2xl
              mx-auto
              text-gray-600
              text-[17px]
              md:text-[19px]
              leading-relaxed
              font-poppins
            "
          >
            Designed with comfort, confidence and care in mind — discover
            premium sanitary and wellness essentials crafted for everyday
            protection.
          </p>
        </div>

        {/* NAVIGATION ARROWS */}
        <div
          className="
            swiper-button-prev
            !w-6
            !h-6
            !bg-white/90
            backdrop-blur-md
            !rounded-full
            !shadow-xl
            border
            border-pink-100
            after:!text-[6px]
            after:!text-[#1A237E]
          "
        ></div>

        <div
          className="
            swiper-button-next
            !w-6
            !h-6
            !bg-white/90
            backdrop-blur-md
            !rounded-full
            !shadow-xl
            border
            border-pink-100
            after:!text-[6px]
            after:!text-[#1A237E]
          "
        ></div>

        {/* PRODUCTS SWIPER */}
        <Swiper
          modules={[Navigation]}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          loop
          spaceBetween={28}
          breakpoints={{
            0: {
              slidesPerView: 1.15,
            },
            640: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 4,
            },
          }}
          className="pb-14"
        >
          {products.map((product) => {
            const expanded = expandedId === product.id;

            const isLong = product.description.length > 80;

            return (
              <SwiperSlide key={product.id}>
                <div className="group h-full">
                  <div
                    className="
                      relative
                      h-full
                      rounded-[32px]
                      bg-white/80
                      backdrop-blur-xl
                      border
                      border-pink-100
                      shadow-[0_10px_40px_rgba(255,192,203,0.15)]
                      overflow-hidden
                      transition-all
                      duration-500
                      hover:-translate-y-2
                      hover:shadow-[0_20px_60px_rgba(255,105,180,0.18)]
                      flex
                      flex-col
                    "
                  >
                    {/* TOP GRADIENT */}
                    <div
                      className="
                        absolute
                        inset-x-0
                        top-0
                        h-32
                        bg-gradient-to-b
                        from-pink-50
                        to-transparent
                      "
                    />

                    {/* IMAGE */}
                    <Link
                      to={`/products/${product.id}`}
                      className="
                        relative
                        flex
                        justify-center
                        items-center
                        pt-10
                        px-5
                      "
                    >
                      <img
                        src={product.image}
                        alt={product.name}
                        className="
                          h-64
                          object-contain
                          transition-transform
                          duration-500
                          group-hover:scale-105
                        "
                      />
                    </Link>

                    {/* CONTENT */}
                    <div
                      className="
                        px-6
                        pb-7
                        pt-2
                        flex
                        flex-col
                        flex-1
                      "
                    >
                      {/* TITLE */}
                      <Link to={`/products/${product.id}`}>
                        <h3
                          className="
                            font-poppins
                            text-[18px]
                            font-semibold
                            text-[#1A237E]
                            leading-snug
                            min-h-[72px]
                          "
                        >
                          {product.name}
                        </h3>
                      </Link>

                      {/* DESCRIPTION */}
                      <p
                        className={`
                          mt-3
                          text-[14px]
                          leading-relaxed
                          text-gray-600
                          font-poppins
                          min-h-[72px]
                          ${expanded ? "" : "line-clamp-3"}
                        `}
                      >
        


<RichText html={product.description} clamp={!expanded} className="min-h-[72px]" />
                      </p>

                      {/* READ MORE */}
                      {isLong && (
                        <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            setExpandedId(expanded ? null : product.id);
                          }}
                          className="
                            mt-2
                            text-pink-500
                            text-sm
                            font-medium
                            hover:text-pink-600
                            text-left
                          "
                        >
                          {expanded ? "Read less" : "Read more"}
                        </button>
                      )}

                      {/* PUSH CONTENT DOWN */}
                      <div className="mt-auto">

                        {/* PRICE */}
                        <div
                          className="
                            mt-6
                            flex
                            items-center
                            gap-3
                          "
                        >
                          {product.price && (
                            <span
                              className="
                                text-2xl
                                font-bold
                                text-[#1A237E]
                              "
                            >
                              ₹{product.price}
                            </span>
                          )}

                          {product.normal_price && (
                            <span
                              className="
                                text-sm
                                text-gray-400
                                line-through
                              "
                            >
                              ₹{product.normal_price}
                            </span>
                          )}
                        </div>

                        {/* BUTTONS */}
                        <div className="mt-6 flex gap-3">

                          {/* VIEW PRODUCT */}
                          <Link
                            to={`/products/${product.id}`}
                            className="
                              flex-1
                              py-3.5
                              px-2
                              rounded-full
                              bg-gradient-to-r
                              from-pink-500
                              to-pink-400
                              text-white
                              font-medium
                              text-sm
                              tracking-wide
                              transition-all
                              duration-300
                              hover:shadow-lg
                              hover:scale-[1.02]
                              flex
                              items-center
                              justify-center
                            "
                          >
                            View Product
                          </Link>

                          {/* CART OR OUT OF STOCK ✅ */}
                          {product.is_out_of_stock ? (
                            <button
                              disabled
                              className="
                                w-14
                                rounded-full
                                border
                                border-gray-200
                                bg-gray-100
                                text-gray-400
                                flex
                                items-center
                                justify-center
                                cursor-not-allowed
                                text-[10px]
                                font-semibold
                                text-center
                                leading-tight
                                px-1
                              "
                            >
                              Out of Stock
                            </button>
                          ) : (
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                addToCart(product);
                                toast.success("Added to cart!", {
                                  duration: 2000,
                                });
                              }}
                              className="
                                w-14
                                rounded-full
                                border
                                border-pink-200
                                bg-white
                                text-[#1A237E]
                                flex
                                items-center
                                justify-center
                                hover:bg-pink-50
                                hover:shadow-md
                                transition-all
                                duration-300
                              "
                            >
                              🛒
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>

        {/* VIEW ALL */}
        <div className="text-center mt-4">
          <Link
            to="/products"
            className="
              inline-flex
              items-center
              gap-3
              px-10
              py-4
              rounded-full
              bg-[#1A237E]
              text-white
              font-medium
              tracking-wide
              transition-all
              duration-300
              hover:scale-105
              hover:shadow-2xl
            "
          >
            Explore All Products
          </Link>
        </div>
      </div>
    </section>
  );
}